const validateFormReady = (formOptions, employerOptions) => {
  return (
    employerOptions.groupNumber.value &&
    employerOptions.address.state.value &&
    formOptions.homeState.value &&
    formOptions.applicantType.value &&
    formOptions.groupType.value &&
    [formOptions.life.value, formOptions.disability.value, formOptions.ci.value].some(p => p)
  )
}

export default validateFormReady